
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEthernetGoogle as ObiEthernetGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ethernet-google.js';
 
 
 

 
 export const ObiEthernetGoogle = createComponent({
   react: React,
   tagName: 'obi-ethernet-google',
   elementClass: ObiEthernetGoogleElement,
   events: {
     
   }
  });
 
 